import { render, staticRenderFns } from "./YouTube.vue?vue&type=template&id=47eac392&"
import script from "./YouTube.vue?vue&type=script&lang=ts&"
export * from "./YouTube.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports